import React from 'react';
import moment from 'moment';
import { List } from 'antd';

export const dateContent = (text, record) => (
  moment(record.created_date)
    .format('DD-MM-YYYY HH:mm')
);

export const changeHistoryContent = (text, record) => {
  if (!record.change_history.length) {
    return 'Initial Create';
  }

  return (
    <List
      size="small"
      dataSource={record.change_history}
      renderItem={item => (
        <List.Item>
          <b>{item.field}</b>
          {' '}
          changed from
          {' '}
          <b>{item.old_value}</b>
          {' '}
          to
          {' '}
          <b>{item.new_value}</b>
        </List.Item>
      )}
    />
  );
};

export const userContent = (text, record) => (
  (record.user) ? `${record.user.last_name}, ${record.user.first_name}` : 'System User'
);
